export const sharedColors = {
  quoteBackground: "rgba(35, 39, 57, 0.7)",
  backdrop: "rgba(35, 39, 57, 0.4)",
  white: "rgba(255, 255, 255, 1)"
};
